import { RootState } from '../../../store';

export const getUsers = (state: RootState) => state.users.users;
export const getUsersLoading = (state: RootState) => state.users.isLoading;
export const getUsersLoadMore = (state: RootState) => state.users.loadMore;
export const getPage = (state: RootState) => state.users.page;
export const getPageSize = (state: RootState) => state.users.pageSize;
